export default __webpack_public_path__ + "static/media/Empty_Location.030b2bff.svg";